// ============================================================
// ANSICHTSSACHE-AGENT – Die Kachel einer Datei
// ============================================================
// Wie eine Datei als Kachel dasteht — im DAM (`dam/…/asset-grid`)
// und in der Karte „Anhänge“ an Ticket und Notiz
// (`attachments/attachment-list`). Eine Gestalt fuer beide, seit
// dem 29.09.2026 („Bitte die Card wie im DAM umsetzen“):
//
//   eine weisse Karte mit runden Ecken, die beim Hinzeigen einen
//   Schatten bekommt; oben die Vorschau im Format 4:3 (Bild als
//   Ausschnitt, sonst das Zeichen der Dateiart), darunter Name und
//   eine Zeile Auskunft; Knoepfe in den oberen Ecken erscheinen
//   erst beim Hinzeigen.
//
// Hier steht nur die Gestalt. Was ein Klick tut, was gezogen
// werden kann und was in den Ecken liegt, entscheidet der
// Aufrufer.
// ============================================================

import { cn } from "@/lib/utils";

/** Die Karte selbst — an das aeussere Element der Kachel. */
export const FILE_TILE_CLASS = cn(
  "group relative block w-full overflow-hidden rounded-xl text-left",
  "bg-bg-primary ring-1 ring-black/[0.04] dark:ring-white/[0.06]",
  "duration-fast ease-standard transition-shadow",
);

/** Hervorgehoben (gewaehlt, Ablageziel) — sonst der Schatten beim Hinzeigen. */
export function fileTileState(highlighted: boolean): string {
  return highlighted ? "ring-accent ring-2" : "hover:shadow-e2";
}

/**
 * Ein Knopf in einer oberen Ecke — erscheint beim Hinzeigen, auf
 * dem Tablet (ohne Zeiger) steht er immer da.
 */
export const FILE_TILE_CORNER_BUTTON =
  "bg-bg-primary/90 text-text-secondary hover:text-text-primary duration-fast grid h-7 w-7 place-items-center rounded-md opacity-0 shadow-sm backdrop-blur-sm transition-opacity group-hover:opacity-100 group-focus-within:opacity-100 [@media(hover:none)]:opacity-100";

/** Die Vorschauflaeche im Format 4:3. */
export function FileTilePreview({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("bg-bg-secondary relative aspect-[4/3] w-full overflow-hidden", className)}>
      {children}
    </div>
  );
}

/** Das Zeichen der Dateiart, mittig in der Vorschau. */
export function FileTileIcon({ children }: { children: React.ReactNode }) {
  return <span className="absolute inset-0 grid place-items-center">{children}</span>;
}

/** Name und eine Zeile Auskunft (Groesse) unter der Vorschau. */
export function FileTileCaption({ title, meta }: { title: string; meta?: React.ReactNode }) {
  return (
    <div className="px-2.5 py-2">
      <p className="text-body-sm text-text-primary truncate font-medium">{title}</p>
      {meta !== undefined && <p className="text-caption text-text-tertiary truncate">{meta}</p>}
    </div>
  );
}
